export default __webpack_public_path__ + "static/car-accident-9b1fe734f9d4e018b22ff4f47bb69688.jpeg";